(() => {
  const CART_RETURN_KEY = 'oa-cart-return-url';

  const initializeWalletLayout = () => {
    const checkout = document.querySelector('.oa-cart-page__dynamic-checkout');
    if (!checkout || checkout.dataset.oaWalletLayoutReady === 'true') return;

    let animationFrame;

    const arrangeWallets = () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(() => {
        const shopPay = checkout.querySelector('shopify-accelerated-checkout-cart > shop-pay-wallet-button');
        const payPal = checkout.querySelector('shopify-accelerated-checkout-cart > shopify-paypal-button');
        if (!shopPay || !payPal) return;

        payPal.style.setProperty('transform', 'none', 'important');

        const checkoutRect = checkout.getBoundingClientRect();
        const shopPayRect = shopPay.getBoundingClientRect();
        const payPalRect = payPal.getBoundingClientRect();
        const gap = 8;
        const buttonWidth = (checkoutRect.width - gap) / 2;
        const targetLeft = checkoutRect.left + buttonWidth + gap;
        const translateX = targetLeft - payPalRect.left;
        const translateY = shopPayRect.top - payPalRect.top;

        payPal.style.setProperty(
          'transform',
          `translate(${translateX}px, ${translateY}px)`,
          'important'
        );
        checkout.classList.add('is-wallet-layout-ready');
      });
    };

    const mutationObserver = new MutationObserver(arrangeWallets);
    mutationObserver.observe(checkout, { childList: true, subtree: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(arrangeWallets);
      resizeObserver.observe(checkout);
    } else {
      window.addEventListener('resize', arrangeWallets);
    }

    checkout.dataset.oaWalletLayoutReady = 'true';
    arrangeWallets();
  };

  const submitCartUpdate = (input, quantity) => {
    input.value = String(Math.max(0, quantity));
    input.form?.requestSubmit();
  };

  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-oa-cart-quantity-change]');
    if (quantityButton) {
      const item = quantityButton.closest('.oa-cart-item');
      const input = item?.querySelector('[data-oa-cart-quantity]');
      if (!input) return;

      const delta = Number.parseInt(quantityButton.dataset.oaCartQuantityChange, 10) || 0;
      const currentQuantity = Number.parseInt(input.value, 10) || 0;
      submitCartUpdate(input, currentQuantity + delta);
      return;
    }

    const removeButton = event.target.closest('[data-oa-cart-remove]');
    if (removeButton) {
      const input = removeButton.closest('.oa-cart-item')?.querySelector('[data-oa-cart-quantity]');
      if (input) submitCartUpdate(input, 0);
      return;
    }

    const closeButton = event.target.closest('[data-oa-cart-close]');
    if (!closeButton) return;

    const savedUrl = sessionStorage.getItem(CART_RETURN_KEY);
    const referrer = document.referrer;
    const cartPath = window.routes?.cart_url || '/cart';

    if (referrer) {
      const referrerUrl = new URL(referrer);
      if (referrerUrl.origin === window.location.origin && referrerUrl.pathname !== cartPath) {
        sessionStorage.removeItem(CART_RETURN_KEY);
        window.history.back();
        return;
      }
    }

    if (savedUrl) {
      const returnUrl = new URL(savedUrl, window.location.origin);
      if (returnUrl.origin === window.location.origin && returnUrl.pathname !== cartPath) {
        sessionStorage.removeItem(CART_RETURN_KEY);
        window.location.assign(returnUrl.href);
        return;
      }
    }

    window.location.assign(window.routes?.root_url || '/');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWalletLayout, { once: true });
  } else {
    initializeWalletLayout();
  }
})();
